import { useState } from "react";

/**
 * 列表页码持久化到 localStorage：刷新、从明细返回都停留在原页。
 * 各列表页传唯一 key（如 "kexi_proj_page"）。
 *
 * 用法：
 *   const [page, setPage] = usePersistedPage("kexi_bp_page");
 *   <Pager page={page} ... onChange={setPage} />
 *
 * 注意：切换筛选条件要回第 1 页时，直接 setPage(1) 即可（会一并持久化）。
 * 调用方若有「筛选变化 effect」，记得跳过首次挂载，否则会覆盖持久化值。
 */
export function usePersistedPage(key: string): [number, (p: number) => void] {
  const [page, setPageState] = useState(() => {
    const n = Number(localStorage.getItem(key));
    return Number.isInteger(n) && n >= 1 ? n : 1;
  });
  const setPage = (p: number) => {
    setPageState(p);
    localStorage.setItem(key, String(p));
  };
  return [page, setPage];
}
